<!-- components/Platform.vue -->
<template>
  <section class="platform" ref="platformSection" id="platform">
    <transition name="fade" appear>
      <h2 v-if="isVisible">{{ lMessages.title }}</h2>
    </transition>
    <transition name="slide-up-fast" appear>
      <p v-if="isVisible" class="subtitle">
        {{ lMessages.subtitle }}
      </p>
    </transition>
    <transition name="pop" appear>
      <div v-if="isVisible" class="video-container">
        <iframe
          v-if="language === 'es'"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/eJ_m-uF2Xm0?si=SEQGolp_tWUQCO4m"
          title="Our Features Video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
        <iframe
          v-else
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/lUNnCh6ve-s?si=8xalHQCE84oTiTMF"
          title="Our Features Video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </transition>
    <transition-group name="slide-up" tag="div" class="feature-grid">
      <div
        v-for="(feature, index) in lMessages.items"
        :key="index"
        class="feature-item"
        :style="{ transitionDelay: `${index * 0.1}s` }"
        v-show="isVisible"
      >
        <div class="feature-content">
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.text }}</p>
        </div>
      </div>
    </transition-group>
  </section>
</template>

<script>
export default {
  props: {
    language: { required: true, default: "en" },
    lMessages: { required: true, default: () => [] }
  },
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const section = this.$refs.platformSection;
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        this.isVisible = true;
      } else if (rect.top > window.innerHeight * 0.01) {
        this.isVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.platform {
  padding: 4rem 2rem;
  text-align: center;
  background: var(--white);
}

h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: black;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.2rem;
  color: var(--textInactiveFixedWhiteBg);
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.video-container {
  max-width: 800px;
  height: 450px;
  margin: 0 auto 3rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  position: relative;
  padding: 2rem;
  background: var(--whiter-gray);
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-content {
  color: var(--background-alpha-fixed);
}

h3 {
  color: var(--blacker-gray);
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

p {
  font-size: 1rem;
  color: var(--textInactiveFixedWhiteBg);
}

/* Animations */
.slide-up-enter-active {
  transition: all 0.8s ease 0.2s;
}
.slide-up-enter {
  opacity: 0;
  transform: translateY(50px);
}

.fade-enter-active {
  transition: opacity 0.8s ease;
}
.fade-enter {
  opacity: 0;
}

.pop-enter-active {
  transition: all 1s ease 0.4s;
}
.pop-enter {
  opacity: 0;
  transform: scale(0.9);
}
.slide-up-fast-enter-active {
  transition: all 0.5s ease;
}
.slide-up-fast-enter {
  opacity: 0;
  transform: translateY(100px);
}
</style>
